module.exports = __webpack_public_path__ + "static/media/neritoIcon.98c97589.svg";